import { ListingType, ListingTypeName, LocalityCommonDistrict as District, LocalityCommonRegion as Region, LocalityType, PropertyStatus, RentalType, SaleMethod } from '@domain-group/fe-allhomes-library/lib/node';
import ResultType from './result-type';
var SALE_STATUS = [PropertyStatus.FOR_SALE.name, PropertyStatus.UNDER_OFFER.name];
var RENTAL_STATUS = [PropertyStatus.AVAILABLE_FOR_RENT.name, PropertyStatus.UNDER_APPLICATION.name];
export default {
  PAGE: 1,
  PAGE_SIZE: 50,
  SORT_ORDER: 'ASC',
  SORT_FIELD: listingType => listingType === ListingTypeName.SALES_RESIDENTIAL ? 'AUCTION' : 'PRICE',
  LOCALITIES: [{
    id: Region.CANBERRA.regionId,
    type: LocalityType.REGION.type,
    slug: Region.CANBERRA.slug
  }, {
    id: District.GREATER_QUEANBEYAN.districtId,
    type: LocalityType.DISTRICT.type,
    slug: District.GREATER_QUEANBEYAN.slug
  }],
  RENTAL_TYPE: [RentalType.RESIDENTIAL.name, RentalType.HOLIDAY_RENTALS.name, RentalType.BUILD_TO_RENT.name],
  SALE_METHOD: Object.keys(SaleMethod),
  PROPERTY_STATUS: {
    [ListingType.SALES_RESIDENTIAL.name]: SALE_STATUS,
    [ListingType.DEVELOPMENTS_RESIDENTIAL.name]: SALE_STATUS,
    [ListingType.RENTAL_RESIDENTIAL.name]: RENTAL_STATUS
  },
  RESULT_TYPE: ResultType.LIST
};